import { render, staticRenderFns } from "./invCenterTransfer.vue?vue&type=template&id=53f0880a&"
import script from "./invCenterTransfer.vue?vue&type=script&lang=js&"
export * from "./invCenterTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports